import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'doc-custom-radio',
  standalone: true,
  imports: [CommonModule],
  template: `
    <label
      class="doc-custom-radio"
      [for]="inputId"
      [class.disabled]="disabled">
      <input
        type="radio"
        class="doc-custom-radio-input"
        [id]="inputId"
        [name]="name"
        [value]="value"
        [checked]="isChecked"
        [disabled]="disabled"
        (change)="onSelect()" />
      <span class="doc-custom-radio-box" [class.checked]="isChecked"></span>
    </label>
  `,
  styleUrl: './doc-custom-radio.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DocCustomRadioComponent),
      multi: true,
    }],
})
export class DocCustomRadioComponent implements ControlValueAccessor {
  @Input() name = '';
  @Input() value: string | number | boolean = '';
  @Input() inputId = '';

  @Input() disabled = false;

  private model: unknown;

  get isChecked(): boolean {
    return this.model === this.value;
  }

  onSelect(): void {
    if (this.disabled) {
      return;
    }

    this.model = this.value;
    this.onChange(this.value);
    this.onTouched();
  }

  private onChange: (value: unknown) => void = () => undefined;
  private onTouched: () => void = () => undefined;

  writeValue(value: unknown): void {
    this.model = value;
  }

  registerOnChange(fn: (value: unknown) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
